const payrollReport = (
  state : Object = { },
  action : Object
) => {
  switch (action.type) {

    case 'REPORTS_SET_PAYROLL':
    {
      const newState = Object.assign({}, state);
      Object
      .keys(action.value)
      .forEach(workerId => {
          if (!newState[workerId]) {
            newState[workerId] = {};
          }
          newState[workerId][action.value[workerId].date] = action.value[workerId]
      })

      return newState;
    }

    case 'REPORTS_DELETE_PAYROLL':
    {
      const newState = Object.assign({}, state);
      const workerId = action.value.workerId;
      const date = action.value.date;

      if (newState[workerId] && newState[workerId][date]){
        delete newState[workerId][date];
      }

      if (Object.keys(newState[workerId]).length === 0){
        //delete worker from redux when no more dates present
        delete newState[workerId];
      }

      return newState;
    }

    default:
      return state
  }
}

export default payrollReport



// WEBPACK FOOTER //
// ./src/infra/reducers/reports/payrollReport.js